
/* injects from baggage-loader */

'use strict';

export default class PrivacyPolicyController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}
